import './register.scss';
import React from 'react';
import { Translate, translate } from 'react-jhipster';
import { connect } from 'react-redux';
import { AvForm, AvField } from 'availity-reactstrap-validation';
import { Row, Col, Alert, Button, TabContent, TabPane, UncontrolledTooltip } from 'reactstrap';
import { Redirect, RouteComponentProps } from 'react-router-dom';
import { IRootState } from 'app/shared/reducers';
import { handleRegister, handleRegisterUpload, reset } from './register.reducer';
import RegisterToken from './registertoken';
import RegisterSim from './registersim';
import ShowMessageModal from './showMessage-modal';
import classnames from 'classnames';
import { width } from '@fortawesome/free-solid-svg-icons/faSave';
import {
  SUCCESS,
  ERROR,
  oauth2,
  APP_LOCAL_DATE_FORMAT,
  Rester_Type,
  IND,
  REGISTER_FACE_ID,
  LINK_TERM_OF_USE,
  ORG
} from 'app/config/constants';
import moment from 'moment';
import ComponentDatePicker from 'app/shared/component/ComponentDatePicker';
import value from '*.json';
import { generateCaptcha } from '../password-reset/password-reset.reducer';
import RegisterBottom from './registerBottom';
import ReactDOM from 'react-dom';
import RegisterAccountORG from './registerAccountORG';
import { login } from 'app/shared/util/utilities';
import MessageModal from 'app/shared/message/message-modal';

export interface IRegisterProps extends StateProps, DispatchProps, RouteComponentProps<{}> {}

export interface IRegisterState {
  urlRedirect: string;
  visible: boolean;
  color: string;
  message: string;
  activeTab: string;
  redirectUSB: boolean;
  redirectSim: boolean;
  showModal: boolean;
  isMobile: boolean;
  disableButtonReg: boolean;
  birthday: Date;
  required: boolean;
  captcha: string;
  preview: any;
  base64Image: string;
  // toolTipOpen: boolean;
  redirectLogin: boolean;
  showMessage: boolean;
}

export class RegisterPage extends React.Component<IRegisterProps, IRegisterState> {
  state: IRegisterState = {
    urlRedirect: '',
    visible: false,
    color: 'info',
    message: '',
    activeTab: '',
    redirectUSB: false,
    redirectSim: false,
    showModal: false,
    isMobile: false,
    disableButtonReg: false,
    birthday: null,
    required: false,
    captcha: '',
    preview: '',
    base64Image: '',
    redirectLogin: false,
    showMessage: false
    // toolTipOpen: false
  };

  componentWillMount() {
    this.props.generateCaptcha();
    let regType = Rester_Type.THUE_BAO_DI_DONG;
    if (this.props.location.state) {
      regType = this.props.location.state.regType;
    }
    window['is_mobile']();
    this.setState({
      isMobile: window['isMobile'],
      activeTab: regType
    });
  }

  componentWillUnmount() {
    this.props.reset();
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.resultReg !== nextProps.resultReg) {
      const { resultReg } = nextProps;

      if (resultReg && resultReg.status === SUCCESS) {
        this.setState({
          disableButtonReg: false,
          redirectLogin: true
        });
        // let timerId = setTimeout(() => {
        //   this.setState({
        //     showMessage: false,
        //     redirectLogin: true
        //   });
        // }, 3000);
      } else if (resultReg && resultReg.status) {
        this.setState({
          disableButtonReg: false,
          visible: true,
          color: 'danger',
          message: resultReg.message && resultReg.message !== ERROR ? resultReg.message : translate('register.messages.error.fail')
        });
      } else {
        this.setState({
          disableButtonReg: false
        });
      }
    }
    if (nextProps.registrationFailure) {
      this.setState({
        disableButtonReg: false,
        visible: true,
        color: 'danger',
        message:
          this.state.activeTab === Rester_Type.THUE_BAO_DI_DONG
            ? translate('register.messages.error.fail')
            : 'Có lỗi xảy ra trong quá trình kết nối tới BHXH. Xin vui lòng chọn hình thức đăng ký khác!'
      });
    }
    if (this.props.responseCap !== nextProps.responseCap) {
      const { responseCap } = nextProps;
      if (responseCap.status === SUCCESS) {
        this.setState({
          captcha: responseCap.message
        });
      }
    } else {
      this.props.generateCaptcha();
    }
  }

  handleValidSubmit = (event, values) => {
    if (!this.state.preview) {
      this.setState({
        visible: true,
        color: 'danger',
        message: 'Bạn phải tải ảnh CMND/CCCD'
      });
      return;
    }

    values.fullName = values.fullName.trim();
    values.identity = values.identity.trim();
    values.mobile = values.mobile.trim();
    values.email = values.email.trim();
    values.base64Image = this.state.preview;
    values.type = IND;

    values.birthday = this.state.birthday ? moment(this.state.birthday).format(APP_LOCAL_DATE_FORMAT) : '';
    if (values.identity.length === 8 && isNaN(values.identity.charAt(0) * 1)) {
      values.passport = values.identity.toUpperCase();
      values.identity = '';
    }

    // if (this.state.activeTab == Rester_Type.BAO_HIEM_XA_HOI) {
    //   values.sic = values.sic.trim();
    // }

    if (!values.birthday) {
      this.setState({
        required: true
      });
      window['autoFocus']('birthday');
    } else {
      this.setState({
        required: false
      });
      this.props.handleRegister(values);
      this.setState({ disableButtonReg: true });
    }
    event.preventDefault();
  };

  onDismiss = () => {
    this.setState({ visible: false });
  };

  setRedirectUSB = () => {
    this.setState({ redirectUSB: true });
  };

  // setRedirectSIM = () => {
  //   this.setState({ redirectSim: true });
  // };

  handleClose = () => {
    this.setState({ showModal: false });
  };

  renderRedirect = () => {
    if (this.state.redirectUSB) {
      return (
        <Redirect
          push
          to={{
            pathname: '/token/register',
            state: {
              userType: this.state.activeTab
            }
          }}
        />
      );
    }
    // if (this.state.redirectSim) {
    //   return <Redirect push to="/sim/register" />;
    // }
  };

  toggleTabs = tab => {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab
      });
    }
  };

  handleChangeDate = date => {
    this.setState({
      birthday: date,
      required: false
    });
  };

  invokeResetCaptcha = () => {
    this.props.generateCaptcha();
  };

  handleImageUpload = event => {
    const file = event.target.files[0];
    if (file) {
      // Kiểm tra định dạng tệp (chỉ cho phép ảnh)
      const validTypes = ['image/jpeg', 'image/png'];
      if (!validTypes.includes(file.type)) {
        this.setErrorMessage('Tệp đính kèm không phải định dạng ảnh hợp lệ.');
        return;
      }

      // Kiểm tra kích thước tệp (tối đa 5MB)
      const maxSizeInBytes = 5 * 1024 * 1024; // 5MB
      if (file.size > maxSizeInBytes) {
        this.setErrorMessage('Tệp đính kèm dung lượng vượt quá 5MB.');
        return;
      }
      const reader = new FileReader();
      reader.onloadend = () => {
        this.setState({
          preview: reader.result
        });
        console.log(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  setErrorMessage(message) {
    this.setState({
      visible: true,
      color: 'danger',
      message: message
    });
  }

  removeSelectedFile = () => {
    this.setState({ preview: '' });
  };

  render() {
    const { urlRedirect } = this.state;
    let regType = this.state.activeTab;
    let _userType = IND;
    if (this.props.location.state) {
      _userType = this.props.location.state.userType;
    }

    if (this.state.redirectLogin) {
      // login(this.props.config);
      return (
        <Redirect
          push
          to={{
            pathname: `/success`,
            state: {
              config: this.props.config
            }
          }}
        />
      );
    }

    // if (urlRedirect !== null && urlRedirect !== '') {
    //   return (
    //     <Redirect
    //       push
    //       to={{
    //         pathname: urlRedirect,
    //         state: {
    //           mobile: this.props.resultReg.register.mobile,
    //           id: this.props.resultReg.register.login,
    //           email: this.props.resultReg.register.email,
    //           type: 'mobile',
    //           fullName: this.props.resultReg.register.fullName
    //         }
    //       }}
    //     />
    //   );
    // }

    return (
      <div>
        {_userType == ORG ? (
          <div>
            <div className="box-register" style={{ display: regType === Rester_Type.USB_KY_SO ? '' : 'none' }}>
              {this.renderRedirect()}
              <Row className="justify-content-center">
                <Col style={{ flex: 1 }}>
                  <h2 className="text-center text-register" id="register-title">
                    <Translate contentKey="register.title">Registration</Translate>
                  </h2>
                  {/* <p className="text-center txtContent">
              <Translate contentKey="register.txtContent" />
            </p> */}
                </Col>
              </Row>
              <Row className="justify-content-center">
                <ul className="tabs">
                  {this.state.isMobile ? null : (
                    <li
                      style={{ display: regType === Rester_Type.USB_KY_SO ? '' : 'none' }}
                      className={classnames({ active: regType === Rester_Type.USB_KY_SO })}
                    >
                      <a
                      // onClick={() => {
                      //   this.toggleTabs('usb');
                      // }}
                      >
                        USB ký số
                      </a>
                    </li>
                  )}
                </ul>
              </Row>
              <Row className="justify-content-center avfield-font">
                <Col style={{ flex: 1 }}>
                  <TabContent activeTab={this.state.activeTab}>
                    <TabPane tabId={Rester_Type.USB_KY_SO}>
                      <RegisterToken userType={_userType} />
                    </TabPane>
                  </TabContent>
                </Col>
              </Row>
              {this.state.isMobile && REGISTER_FACE_ID ? (
                <Button className="btnSign mt-3" style={{ width: '100%' }} id="register-face" color="primary" type="button" block>
                  <span className="spanText">{translate('register.form.buttonRegisterFace')}</span>
                </Button>
              ) : null}
            </div>
            <div className="box-register2" style={{ display: regType === Rester_Type.THUE_BAO_DI_DONG ? '' : 'none' }}>
              <RegisterAccountORG userType={regType} />
              {this.state.isMobile && REGISTER_FACE_ID ? (
                <Button className="btnSign mt-3" style={{ width: '100%' }} id="register-face" color="primary" type="button" block>
                  <span className="spanText">{translate('register.form.buttonRegisterFace')}</span>
                </Button>
              ) : null}
            </div>
          </div>
        ) : (
          <div className="box-register1">
            <MessageModal type={SUCCESS} showModal={this.state.showMessage} message={'Chúc mừng bạn đã đăng ký thành công'} />
            <div style={{ display: regType === Rester_Type.EMAIL || regType === Rester_Type.MOBILE ? '' : 'none' }}>
              <RegisterAccountORG userType={regType} />
            </div>
            {this.renderRedirect()}
            <Row
              className="justify-content-center"
              style={{ display: regType === Rester_Type.EMAIL || regType === Rester_Type.MOBILE ? 'none' : '' }}
            >
              <Col style={{ flex: 1 }}>
                <h2 className="text-center text-register" id="register-title">
                  <Translate contentKey="register.title">Registration</Translate>
                </h2>
              </Col>
            </Row>
            <Row className="justify-content-center">
              <ul className="tabs">
                <li
                  style={{ display: regType === Rester_Type.THUE_BAO_DI_DONG ? '' : 'none' }}
                  className={classnames({
                    active: regType === Rester_Type.THUE_BAO_DI_DONG
                  })}
                >
                  <a>
                    Chào mừng bạn đến với Hệ thống - Nền tảng quản lý định danh và xác thực
                    <div>Bộ Nông nghiệp và Môi trường</div>
                  </a>
                </li>
                {this.state.isMobile ? null : (
                  <li
                    style={{ display: regType === Rester_Type.USB_KY_SO ? '' : 'none' }}
                    className={classnames({ active: regType === Rester_Type.USB_KY_SO })}
                  >
                    <a>
                      Chào mừng bạn đến với Hệ thống - Nền tảng quản lý định danh và xác thực
                      <div>Bộ Nông nghiệp và Môi trường</div>
                    </a>
                  </li>
                )}
              </ul>
            </Row>
            <Row className="justify-content-center avfield-font">
              <Col style={{ flex: 1 }}>
                <TabContent activeTab={this.state.activeTab}>
                  <TabPane tabId={Rester_Type.USB_KY_SO}>
                    <RegisterToken userType={_userType} />
                  </TabPane>

                  <TabPane tabId={regType === Rester_Type.THUE_BAO_DI_DONG && _userType == IND ? Rester_Type.THUE_BAO_DI_DONG : ''}>
                    {/* <p style={{ textAlign: 'center', marginBottom: '10%' }}>(Chỉ dành cho công dân)</p> */}
                    <Alert color={this.state.color} isOpen={this.state.visible} toggle={this.onDismiss}>
                      {this.state.message}
                    </Alert>
                    <AvForm id="register-form" onValidSubmit={this.handleValidSubmit}>
                      <Row style={{ flex: 1 }}>
                        <Col style={{ flex: 0.8 }}>
                          <AvField
                            name="identity"
                            label={translate('global.form.cmt.label')}
                            placeholder={translate('global.form.cmt.placeholder')}
                            // autoFocus={!this.state.isMobile}
                            // type="number"
                            validate={{
                              required: { value: true, errorMessage: translate('register.messages.validate.cmt/cccd.required') },
                              pattern: {
                                value: '^([0-9]{9}|[0-9]{12})+$',
                                errorMessage: translate('register.messages.validate.cmt/cccd.pattern')
                              },
                              minLength: { value: 9, errorMessage: translate('register.messages.validate.cmt/cccd.minlength') },
                              maxLength: { value: 12, errorMessage: translate('register.messages.validate.cmt/cccd.minlength') }
                            }}
                          />
                        </Col>
                        <Col style={{ flex: 0.2 }}>
                          <label style={{ paddingTop: '45%' }} htmlFor="file-upload">
                            <img src={require('app/images/camera.png')} alt="Upload Icon" style={{ cursor: 'pointer' }} />
                          </label>
                          <AvField
                            id="file-upload"
                            name="file"
                            type="file"
                            accept="image/*"
                            style={{ display: 'none' }}
                            onChange={this.handleImageUpload}
                          />
                        </Col>
                      </Row>
                      <Row style={{ paddingLeft: '5%' }}>
                        <Col style={{ flex: 0.9 }}>
                          {this.state.preview && <img src={this.state.preview} alt="Preview" style={{ width: '345px', height: '215px' }} />}
                        </Col>
                        <Col style={{ flex: 0.1 }}>
                          {this.state.preview && <img src={require('app/images/X.png')} onClick={this.removeSelectedFile} />}
                        </Col>
                      </Row>
                      <AvField
                        name="fullName"
                        label={translate('global.form.fullname.label')}
                        placeholder={translate('global.form.fullname.placeholder')}
                        validate={{
                          required: { value: true, errorMessage: translate('register.messages.validate.fullname.required') },
                          maxLength: { value: 250, errorMessage: 'Họ tên quá dài' }
                        }}
                      />

                      <ComponentDatePicker
                        name="birthday"
                        value={this.state.birthday}
                        required={this.state.required}
                        handleChange={this.handleChangeDate}
                        label={translate('global.form.birthday.label')}
                        placeHolder="dd/mm/yyyy"
                        readOnly={false}
                      />

                      <AvField
                        name="email"
                        label={translate('global.form.email.require')}
                        placeholder={translate('global.form.email.placeholder')}
                        type="email"
                        validate={{
                          required: { value: true, errorMessage: translate('register.messages.validate.email.required') },
                          maxLength: { value: 250, errorMessage: translate('global.messages.validate.email.maxlength') },
                          email: { value: true, errorMessage: translate('register.messages.validate.email.pattern') }
                        }}
                      />

                      <AvField
                        name="mobile"
                        label={translate('global.form.mobile.label')}
                        placeholder={translate('global.form.mobile.placeholder')}
                        validate={{
                          // required: { value: true, errorMessage: translate('global.messages.validate.mobile.required') },
                          number: { value: true, errorMessage: translate('global.messages.validate.mobile.invalid') },
                          minLength: { value: 10, errorMessage: translate('global.messages.validate.mobile.minlength') },
                          maxLength: { value: 11, errorMessage: translate('global.messages.validate.mobile.maxlength') }
                        }}
                      />

                      <label>{translate('global.form.code.label')}</label>
                      <Row style={{ flex: 1 }}>
                        <Col style={{ flex: 0.6 }}>
                          <AvField
                            name="captcha"
                            label=""
                            placeholder="Nhập mã xác thực"
                            type="text"
                            validate={{
                              required: { value: true, errorMessage: 'Nhập mã xác thực' }
                            }}
                          />
                        </Col>

                        <Col style={{ flex: 0.3 }}>
                          <img style={{ height: '39px' }} src={`data:image/jpeg;base64,${this.state.captcha}`} alt="" />
                        </Col>

                        <Col style={{ flex: 0.1 }}>
                          <img
                            // style={{ marginTop: '40px' }}
                            className=""
                            src={require('../../../images/header/refresh.svg')}
                            onClick={this.invokeResetCaptcha}
                            alt=""
                          />
                        </Col>
                      </Row>

                      <label className="lbl-term">
                        <Translate contentKey="register.term1" />
                        <a target="_blank">
                          <Translate contentKey="register.term2" />
                        </a>
                        <Translate contentKey="register.term3" />
                      </label>

                      <Button
                        className="btn-register"
                        type="submit"
                        disabled={this.state.disableButtonReg}
                        style={{ width: '100%', margin: '0 auto' }}
                        block
                      >
                        <Translate contentKey="register.form.button">Register</Translate>
                      </Button>

                      <div style={{ marginTop: '10px' }}>
                        <RegisterBottom isInsurance={false} />
                      </div>
                    </AvForm>
                  </TabPane>
                </TabContent>
              </Col>
            </Row>
            {this.state.isMobile && REGISTER_FACE_ID ? (
              <Button className="btnSign mt-3" style={{ width: '100%' }} id="register-face" color="primary" type="button" block>
                <span className="spanText">{translate('register.form.buttonRegisterFace')}</span>
              </Button>
            ) : null}
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (storeState: IRootState) => ({
  resultReg: storeState.register.resultReg,
  currentLocale: storeState.locale.currentLocale,
  registrationFailure: storeState.register.registrationFailure,
  responseCap: storeState.passwordReset.responseCaptcha,
  responseUpload: storeState.register.responseUpload,
  config: storeState.applicationProfile.config
});

const mapDispatchToProps = { handleRegister, reset, generateCaptcha, handleRegisterUpload };
type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RegisterPage);
